import React from "react"
import {Box, Typography} from "@mui/material"

import {ColorSquare} from "../../../../@components"


export default function colorColumn() {
	return {
		name: "color", label: "Color",
		options: {
			sort: false,
			headerAlign: 'center',
			customBodyRowRenderLite: value => <Box sx={{  display: 'flex', justifyContent: 'center', gap: 1  }}>
				<ColorSquare value={value} />
				<Typography variant="caption">
					{value}
				</Typography>
			</Box>
		}
	}
}